import React from 'react';
import styled from 'styled-components';
import {
  ADDRESS_CONFIRMATION_CHECKBOX_LABEL,
} from '../constants/addressConfirmation';

// קומפוננטת checkbox משותפת לאישור התאמת הכתובת לכתובת המעודכנת במשרד הפנים.
// מיועדת לשילוב בכל מסך שמכיל שדה כתובת — כרגע בשימוש במסך חתימת ליד בלבד.

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`;

const LabelRow = styled.label<{ hasError?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
  color: ${(props) => (props.hasError ? 'var(--error-color)' : 'var(--text-primary)')};
`;

const CheckboxInput = styled.input<{ hasError?: boolean }>`
  margin-top: 3px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: var(--primary-color);
  outline: ${(props) => (props.hasError ? '2px solid var(--error-color)' : 'none')};
  outline-offset: 2px;
`;

const RequiredMark = styled.span`
  color: var(--error-color);
  margin-right: 2px;
`;

const ErrorText = styled.span`
  font-size: 12px;
  color: var(--error-color);
  margin-top: 2px;
`;

interface AddressConfirmationCheckboxProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  error?: string;
}

const AddressConfirmationCheckbox: React.FC<AddressConfirmationCheckboxProps> = ({
  id = 'address-confirmation-checkbox',
  checked,
  onChange,
  disabled = false,
  error,
}) => {
  const errorId = error ? `${id}-error` : undefined;

  return (
    <Wrapper>
      <LabelRow htmlFor={id} hasError={!!error}>
        <CheckboxInput
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          hasError={!!error}
          aria-required="true"
          aria-invalid={!!error}
          aria-describedby={errorId}
        />
        <span>
          {ADDRESS_CONFIRMATION_CHECKBOX_LABEL}
          <RequiredMark aria-hidden="true">*</RequiredMark>
        </span>
      </LabelRow>
      {error && <ErrorText id={errorId}>{error}</ErrorText>}
    </Wrapper>
  );
};

export default AddressConfirmationCheckbox;
